<div class="activity-error-wrapper">
  <p>
    We are unable to display results from this Activity due to errors.
  </p>

  <siq-error-list
    [activity]="activity"
  ></siq-error-list>
</div>
